import { render } from "./EditTest.vue?vue&type=template&id=48d7a2a7&scoped=true"
import script from "./EditTest.vue?vue&type=script&lang=js"
export * from "./EditTest.vue?vue&type=script&lang=js"

import "./EditTest.vue?vue&type=style&index=0&id=48d7a2a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d7a2a7"]])

export default __exports__